import { GenreListOut } from '../../../../store/apiLibx';
import { GenreOut } from '../../../../store/api';
import { TFunction } from 'i18next';

export const localiseGenresListMapper = (genreList: GenreListOut | undefined, t: TFunction) => {
    return genreList?.genres?.map((genre: GenreOut) => {
        const hasSubGenre = genre.id?.includes('->');
        const [genreId, subGenreId] = genre.id?.split('->') ?? [];
        const [defaultGenreName, defaultSubgenreName] = genre.name?.split('>') ?? [];

        const name = hasSubGenre
            ? t('yourLocalContent.yourTitles.genreConcat', {
                  genre: t(`filters:genre.${genreId}`, defaultGenreName),
                  subGenre: t(`filters:genre.${subGenreId}`, defaultSubgenreName),
                  defaultValue: ''
              })
            : t(`filters:genre.${genreId}`, genre.name ?? '');
        return {
            ...genre,
            name,
            id: genre.id
        };
    });
};
